module.exports = __webpack_public_path__ + "angular/components/dropdownmenu/ebBasicDropDownMenu-50bde32b.html";


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/uielements/dropdownmenu/ebBasicDropDownMenu.html
// module id = 61
// module chunks = 0